module.exports = __webpack_public_path__ + "img/delivery-proccess.0fd61fe1.svg";